import React, { useState } from 'react';
import api from '../../api/api';

export default function EditionsPositions({ editions, positions, activeTab, onRefresh, resources }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [isAdding, setIsAdding] = useState(false);
  const [newForm, setNewForm] = useState({
    name: '',
    media_resource_id: '',
    is_active: true
  });

  const data = activeTab === 'Editions' ? editions : positions;
  const filteredData = data.filter(item => 
    item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (item.media_resource && item.media_resource.toLowerCase().includes(searchTerm.toLowerCase()))
  );

  const label = activeTab === 'Editions' ? 'Edition' : 'Position';
  const apiPath = activeTab === 'Editions' ? '/master/editions' : '/master/positions';

  const itemsPerPage = 10;
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const currentItems = filteredData.slice((page - 1) * itemsPerPage, page * itemsPerPage);

  const handleEdit = (item) => {
    setEditingId(item.id);
    // Find media_resource_id from resources list by name
    const res = resources.find(r => r.name === item.media_resource);
    setEditForm({ ...item, media_resource_id: res?.id || '' });
  };

  const handleSave = async () => {
    try {
      await api.put(`${apiPath}/${editingId}`, {
        name: editForm.name,
        media_resource_id: editForm.media_resource_id,
        is_active: editForm.is_active
      });
      setEditingId(null);
      onRefresh();
    } catch (error) {
      alert(`Failed to update ${label}`);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure?')) return;
    try {
      await api.delete(`${apiPath}/${id}`);
      onRefresh();
    } catch (error) {
      alert(`Failed to delete ${label}`);
    }
  };

  const handleAdd = async () => {
    try {
      await api.post(apiPath, {
        name: newForm.name,
        media_resource_id: newForm.media_resource_id
      });
      setIsAdding(false);
      setNewForm({ name: '', media_resource_id: '', is_active: true });
      onRefresh();
    } catch (error) {
      alert(`Failed to add ${label}`);
    }
  };

  return (
    <>
      <div className="admin-card-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: '1.5rem', flex: 1 }}>
          <h3>{activeTab}</h3>
          <div className="search-box" style={{ position: 'relative', flex: 1, maxWidth: '400px' }}>
            <span style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }}>🔍</span>
            <input 
              type="text" 
              placeholder={`Search ${activeTab.toLowerCase()}...`} 
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setPage(1);
              }}
              style={{ 
                width: '100%', 
                padding: '0.6rem 1rem 0.6rem 2.5rem', 
                borderRadius: '0.5rem', 
                border: '1px solid #e2e8f0',
                fontSize: '0.9rem'
              }}
            />
          </div>
        </div>
        <button className="btn-primary small-btn" onClick={() => setIsAdding(true)}>+ Add {label}</button>
      </div>

      {isAdding && (
        <div style={{ padding: '1.5rem', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
          <h4>Add New {label}</h4>
          <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem', flexWrap: 'wrap' }}>
            <input 
              type="text" 
              placeholder={`${label} Name`} 
              value={newForm.name} 
              onChange={e => setNewForm({...newForm, name: e.target.value})}
              style={{ padding: '0.5rem', borderRadius: '0.4rem', border: '1px solid #cbd5e1', minWidth: '250px' }}
            />
            <button className="btn-primary small-btn" onClick={handleAdd}>Save</button>
            <button className="btn-secondary small-btn" onClick={() => setIsAdding(false)}>Cancel</button>
          </div>
        </div>
      )}

      <div className="admin-table-wrapper">
        <table className="admin-table">
          <thead>
            <tr>
              <th>{label} Name</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((item) => (
              <tr key={item.id}>
                <td>
                  {editingId === item.id ? (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                      <input 
                        type="text" 
                        value={editForm.name} 
                        onChange={e => setEditForm({...editForm, name: e.target.value})} 
                        style={{ padding: '0.3rem', borderRadius: '0.3rem', border: '1px solid #cbd5e1' }}
                      />
                    </div>
                  ) : (
                    <strong>{item.name}</strong>
                  )}
                </td>
                <td>
                  {editingId === item.id ? (
                    <input type="checkbox" checked={editForm.is_active} onChange={e => setEditForm({...editForm, is_active: e.target.checked})} />
                  ) : (
                    <span className={`status-badge ${item.is_active ? 'active' : 'inactive'}`}>
                      {item.is_active ? 'Active' : 'Inactive'}
                    </span>
                  )}
                </td>
                <td>
                  <div className="actions-cell">
                    {editingId === item.id ? (
                      <button className="action-btn" onClick={handleSave} title="Save">💾</button>
                    ) : (
                      <button className="action-btn" onClick={() => handleEdit(item)} title="Edit">✏️</button>
                    )}
                    <button className="action-btn" onClick={() => handleDelete(item.id)} title="Delete">🗑️</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="pagination-container" style={{ padding: '1rem' }}>
          <button className="pagination-btn" disabled={page === 1} onClick={() => setPage(page - 1)}>Prev</button>
          <span>Page {page} of {totalPages}</span>
          <button className="pagination-btn" disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</button>
        </div>
      )}
    </>
  );
}
